import { Spin } from 'antd';
import { Suspense, lazy } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import Layout from '../../../components/Layout';
import Menu from '../../../components/Layout/Menu';

const TopicCreateContent = lazy(() => import('../../../components/Pages/Topics/Create'));

export default function TopicCreate(): JSX.Element | null {
  document.title = `${process.env.REACT_APP_TITLE}: Topic Create page`;

  return (
    <Layout LeftMenu={Menu} transparent>
      <Suspense fallback={<Spin spinning indicator={<LoadingOutlined spin />} />}>
        <TopicCreateContent />
      </Suspense>
    </Layout>
  );
}
